import request from '@/utils/request';

// 导出店铺归属信息
export function fetchClassificationsIndexList(data) {
  return request('/api/classifications-index-list', {
    data,
    method: 'POST',
  });
}

export async function fetchClassifications() {
  return request('/api/classifications-list', {
    method: 'POST',
  });
}

// 标准分类-尼斯分类-导出
export function exportNiceType(data) {
  return request('/api/classifications/export-nice-type', { method: 'POST', data });
}

// 获取尼斯分类
export const getNiceType = params => {
  return request('/api/classifications/nice-type-list', {
    method: 'GET',
    params,
  });
};

//标准分类-spu列表导出
export function exportSpuList(data) {
  return request('/api/classifications/nice-type-spu-list', {
    method: 'POST',
    data,
    headers: {
      export: 'xlsx',
    },
  });
}

// 标准分类-单个编辑尼斯分类
export function updateNiceType(data) {
  return request('/api/classifications/bind-nice-type-value', { method: 'POST', data });
}

// 标准分类-批量修改尼斯分类
export function batchUpdateNiceType(data) {
  return request('/api/classifications/batch-bind-nice-type-value', { method: 'POST', data });
}

//标准分类-尼斯分类-导入-模版获取
export function getNiceTypeImportTemplate() {
  return request('/api/classifications/import-nice-type', { method: 'GET' });
}

// 标准分类-spu列表-批量编辑尼斯分类
export function batchUpdateSpuNiceType(data) {
  return request('/api/classifications/batch-nice-type-spu-edit', { method: 'POST', data });
}
// 标准分类-spu列表-单个编辑尼斯分类
export function updateSpuNiceType(data) {
  return request('/api/classifications/nice-type-spu-edit', { method: 'POST', data });
}

// 标准分类-尼斯分类-导入-开始
export function importNiceType(data) {
  return request('/api/classifications/import-nice-type', { method: 'POST', data });
}

// 标准分类-手动导入特殊spu获取模版
export function getClassificationsNiceTypeSpuTemManual() {
  return request('/api/classifications/nice-type-spu-tem-spe', { method: 'GET' });
}

// 标准分类-手动导入特殊spu-开始
export function importClassificationsNiceTypeSpuTemManual(data) {
  return request('/api/classifications/nice-type-spu-tem-spe', { method: 'POST', data });
}
// 标准分类-查看标准分类的尼斯分类日志
export function getNiceTypeLog(params) {
  return request('/api/classifications/nice-type-logs', { method: 'GET', params });
}
// 标准分类-spu列表-操作人列表
export function getSpuOperatorList(data) {
  return request('/api/classifications/nice-type-spu-operator-list', { method: 'POST', data });
}

// 标准分类-特殊spu列表获取批量导出尼斯分类导入-开始
export function importClassificationsNiceTypeSpuTem(data) {
  return request('/api/classifications/nice-type-spu-tem', { method: 'POST', data });
}

// 标准分类-特殊spu列表获取批量导出尼斯分类导入模版
export function getClassificationsNiceTypeSpuTem() {
  return request('/api/classifications/nice-type-spu-tem', { method: 'GET' });
}
//标准分类-spu列表
export function getSpuList(data) {
  return request('/api/classifications/nice-type-spu-list', { method: 'POST', data });
}

// 尼斯分类设置-通知
export function getNiceTypeNotice(data) {
  return request('/api/classifications/check-new-flag', { method: 'POST', data });
}
